
import { Book, HelpCircle, Globe } from "lucide-react";
import { FaAndroid } from "react-icons/fa";
import { NavigationItems } from "./types";

export const navigationItems: NavigationItems = {
  learn: [{
    title: "How To Play",
    href: "/how-to-play",
    icon: Book
  }, {
    title: "FAQ",
    href: "/faq",
    icon: HelpCircle
  }],
  play: [{
    title: "Android",
    description: "Available on Google Play",
    href: "https://play.google.com/apps/testing/com.RTz.TWCGame",
    icon: FaAndroid
  }, {
    title: "Web",
    description: "Play directly in your browser",
    href: "https://web.frontrunnergame.com",
    icon: Globe
  }]
};
